module.exports = __webpack_public_path__ + "img/blog-4.ebef1852.jpg";